import React from "react";
import { Box } from "@mui/material";
import ContactSupportOutlinedIcon from "@mui/icons-material/ContactSupportOutlined";
import Dialog from "./dialog/Dialog";
import Text from "./text/Text";
import { errorIcons } from "./images";
import {
  backToHome,
  checkAccountStatus,
  errorLabel,
  helpMsg,
  helpUs,
} from "./messages";
import Button from "./button/Button";
import Clipboard from "./clipboard/Clipboard";

function InvalidErrorModal({
  isOpenInvalidQRModal,
  setIsOpenInvalidQRModal,
  icon,
  message,
  subMessage,
  isShowHelpSection = false,
  direction,
  customClass,
  isShowErrorSection = false,
  errorResponse,
  isFromBrowser,
  btnTxt = backToHome,
  handleModalClose,
  redirectToAccountStatus = false,
  isAdditionalFeature = false,
  additionalFeature,
  handleButtonAction,
  isButtonDisable = false,
  handleRedirectionToAccountStatus,
}) {
  const showAdditionalSection = () => {
    if (isShowHelpSection) {
      return (
        <Box className="help-section">
          <Text
            className="default-text"
            size={16}
            font="semibold"
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <ContactSupportOutlinedIcon
              sx={{
                height: "24",
                width: "24",
                marginRight: "6px",
                color: "#041F61 !important",
              }}
            />
            {helpUs}
          </Text>
          <Text className="grey-text" size={14} font="regular" variant="body1">
            {helpMsg}
          </Text>
          <Button
            variant="outlined"
            style={{
              marginTop: "18px",
            }}
            label={backToHome}
            onClick={() => {
              handleModalClose();
            }}
          />
        </Box>
      );
    } else if (isShowErrorSection) {
      return (
        <Box className="error-section">
          <Box
            borderBottom="1px solid #F6F3F3"
            display="flex"
            justifyContent="space-between"
            pb="16px"
            mb="16px"
          >
            <Text className="default-text" size={16} font="semibold">
              {errorLabel}
            </Text>
            <Clipboard text={errorResponse} height="18px" width="18px" />
          </Box>
          <Text className="grey-text" size={14} font="regular">
            {errorResponse}
          </Text>
        </Box>
      );
    }
  };

  return (
    <Dialog
      isOpenModal={isOpenInvalidQRModal}
      setIsOpenModal={setIsOpenInvalidQRModal}
      directionToOpen={direction}
      isShowCloseIcon={true}
      handleAction={() => {
        handleModalClose();
      }}
    >
      <Box className={customClass}>
        <Box className="error-modal-container">
          <Box> {errorIcons[icon]}</Box>
          <Text
            className="default-text"
            size={22}
            font="semibold"
            // sx={{ marginTop: "8px" }}
          >
            {message}
          </Text>
          <Text
            className="grey-text"
            size={isFromBrowser ? 16 : 14}
            font="regular"
            variant="body1"
            sx={{ wordBreak: "break-word" }}
          >
            {subMessage}
          </Text>
          {isAdditionalFeature && additionalFeature()}
          {redirectToAccountStatus && (
            <Text
              className="txt-uppercase cursor-pointer"
              size={14}
              font="semibold"
              sx={{ color: "#2A67FF", mt: "24px" }}
              onClick={handleRedirectionToAccountStatus}
            >
              {checkAccountStatus}
            </Text>
          )}
          {isShowHelpSection || isShowErrorSection ? (
            showAdditionalSection()
          ) : (
            <Box className="close-modal">
              <Button
                fullWidth
                variant="contained"
                label={btnTxt}
                onClick={() => {
                  handleButtonAction();
                }}
                disabled={isButtonDisable}
              />
            </Box>
          )}
        </Box>
      </Box>
    </Dialog>
  );
}

export default InvalidErrorModal;
